<template>
  <div class="relationItem">
    <backToIngredients v-if="this.$root.isIngredients"> </backToIngredients>
    <div v-if="!this.$root.isIngredients">
      <p class="heading" v-if="(!needSetup && show) || admin">{{heading}}
        <font-awesome-icon :class="['settings', settingsMode ? 'active' : '']" @click="settingsMode = !settingsMode" v-if="admin" :icon="['fas', 'cog']" />
      </p>
    </div>    
    <div v-if="this.$root.isIngredients && (items.length > 1 || items != undefined )">
      <p class="heading"><webmessage searchKey="wsm_productsThatContainIngredient" :text="$root.language.wsm_productsThatContainIngredient"></webmessage>{{ingredientName}}</p>
    </div>
    <settingsComponent v-if="settingsMode && admin" @saveSettings="getItems" :contentid="contentid" :saving="saving" :settings="relationSettings"></settingsComponent>
    <div class="needSetup" v-if="needSetup && admin && !settingsMode && !saving">
      Need setup
    </div>
    <div v-if="show">
      <articles v-if="!settingsMode && relationSettings.mode == 'articles' && !needSetup && !saving" :items="items" :resultNo="relationSettings.resultNo" :loaded="loaded" :showImage="relationSettings.showImage"></articles>
      <products v-if="!settingsMode && relationSettings.mode == 'products' && !needSetup && !saving" :items="items" :resultNo="relationSettings.resultNo" :productid="relationID" :loaded="loaded" :showImage="relationSettings.showImage"></products>
    </div>
    <div v-else>
      <div class="zeroResults" v-if="!settingsMode && admin && !needSetup">
        Zero results with current settings. <br><br>This widget will be invisible for users.
      </div>
    </div>
  </div>
</template>

<script>
  import backToIngredients from './backToIngredients.vue'
  import axios from 'axios'
  const articles = () =>
    import ('./articles.vue')
  const products = () =>
    import ('./products.vue')
  const settingsComponent = () =>
    import ('./settings2.vue')
  export default {
    components: {
      settingsComponent,
      articles,
      products,
      backToIngredients
    },
    name: 'relationWidget',
    props: ["admin", "contentid", "newsid", "productid", "settings"],
    data() {
      return {
        items: [],
        loaded: false,
        settingsMode: false,
        show: true,
        heading: '',
        relationSettings: 'init',
        saving: false,
        relationID: 0,
        currentPageMode: '',
        searchCrit: {},
        ingredientssectionid: ''
      }
    },
    watch: {
      relationSettings: function() {
        this.heading = this.relationSettings.mode == 'products' ? this.$root.language.wsm_relatedProducts : this.$root.language.wsm_relatedArticles
      },
      deep: true,
    },
    computed: {
      needSetup: function() {
        return ((this.settings.activeTags.length == 0 && this.settings.mode == 'articles') || (typeof this.relationSettings.activeTags != 'undefined' && this.relationSettings.activeTags.length == 0 && this.relationSettings.mode == 'articles')) || typeof this.relationID == 'undefined'
      },
      ingredientName: function() {  
        try {
          return this.$root.ingredientname;
        } catch (error) {
          // Handle the error here
          console.error('An error occurred:', error);
          return '';
        }         
      }
    },
    methods: {
      getItems: function(settings) {
        this.loaded = false;
        if (settings != null) {
          this.relationSettings = settings;
          this.$root.settings = settings;
        }
        switch (this.relationSettings.mode) {
          case 'articles':
            var url = new URL(window.location.href);
            var c = url.searchParams.get("sectionId");
            this.searchCrit = {
              target: {
                news: {
                  tagId: typeof c != 'undefined' && c != null ? c : parseInt(this.relationSettings.activeTags[0]),
                  noOfResults: this.relationSettings.resultNo
                }
              }
            }
            if (this.relationSettings.attrs.attr.length != 0 || this.relationSettings.attrs.values.length != 0) {
              this.searchCrit["attributeIds"] = this.relationSettings.attrs.values;
            }
            if (this.currentPageMode == 'news') {
              this.searchCrit["newsId"] = this.relationID;
            } else if (this.currentPageMode == 'product') {
              this.searchCrit["productId"] = this.relationID;
            }
            if (this.relationSettings.featuredMode) {
              this.searchCrit.target.news["sortOrder"] = "featured";
            }
            break;
          case 'products':
            this.searchCrit = {
              target: {
                products: {
                  includeSubProducts: false,
                  noOfResults: this.relationSettings.resultNo
                }
              }
            }
            if (this.currentPageMode == 'news') {
              this.searchCrit["newsId"] = this.relationID;
              this.searchCrit["attributeIds"] = this.relationSettings.categoriesAllowed
            } else if (this.currentPageMode == 'product') {
              this.searchCrit["attributeIds"] = this.relationSettings.categoriesAllowed
              this.searchCrit["productId"] = this.relationID;
            }
            break;
        }
        axios.post(basedir + '/ajaxRequestServlet?mode=Search', this.searchCrit, {
            headers: {
              'Content-type': 'application/json'
            }
          })
          .then((response) => {
            if (Object.keys(response.data).length <= 0) {
              this.show = false;
              this.saving = false;
              this.settingsMode = false;
              this.loaded = false;
              if (!this.admin) {
                document.getElementById("col2").remove()
              }
            } else {
              switch (this.settings.mode) {
                case 'articles':
                  this.items = response.data.news
                  break;
                case 'products':
                  this.items = response.data.productsByAttribute
                  break;
              }
              this.show = true;
              this.loaded = true;
              this.settingsMode = false;
              this.saving = false;
            }
          })
      }
    },
    async mounted() {
      this.relationSettings = this.settings
      if (!this.needSetup) {
        if (this.newsid != "") {
          this.relationID = this.newsid;
          this.currentPageMode = 'news'
        } else if (this.productid != "") {
          this.relationID = this.productid
          this.currentPageMode = 'product'
        }
        await this.getItems(null);
      } else {
        if (this.$root.admin == "true") {
          alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i> <b>[ADMIN]</b> This page has an unconfigured widget');
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" scoped>
  .relationItem {
    max-width: 345px;
    margin-bottom: 20px;
  }
  .heading {
    color: #00456f;
    font-weight: bold;
  }
  .needSetup {
    text-align: center;
    width: 100%;
    height: 100px;
    vertical-align: middle;
    position: relative;
    padding-top: 25%;
    border: 2px dashed #00456f;
    font-size: 2.5em;
    color: #c77575;
    font-weight: bold;
  }
  .zeroResults {
    text-align: center;
    width: 100%;
    height: auto;
    vertical-align: middle;
    position: relative;
    line-height: 1em;
    padding: 12px;
    padding-right: 0;
    padding-left: 0;
    border: 2px dashed #00456f;
    font-size: 2em;
    color: #c77575;
    font-weight: bold;
  }
  .settings {
    cursor: pointer;
    float: right;
    margin-top: 4px;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    &:hover {
      transform: scale(1.1)
    }
  }
  .settings.active {
    color: #4cad16;
  }
  hr {
    margin-top: 14px;
    margin-bottom: 18px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter,
  .fade-leave-to
  /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
  @media only screen and (max-width: 700px) {
    .relationItem {
      max-width: unset;
    }
  }
</style>
